// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EknFJ","copyright":"Footer_copyright__MDxUP","extraPadding":"Footer_extraPadding__mqcJh"};